import isNil from "lodash-es/isNil";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useLocation } from "wouter";
import { logger } from "../../common/logger";

import cartStore from "../../stores/cart/cartStore";
import subscriptionStore from "../../stores/subscriptionStore";
import Button from "../Button";
import Select from "../common/Select";
import Loading from "../Loading";
import ShortcutBox from "./ShortcutBox";

const ShortcutChangeSubscription = () => {
   const [_, redirectTo] = useLocation();
   const [showModal, setShowModal] = useState(false);

   const startEdit = (orderNumber: string | null) => {
      if (isNil(orderNumber)) {
         logger.warn("subscription", "Missing order number when starting edit of subscription");
         return;
      }
      setShowModal(true);
      subscriptionStore.fetchSubscriptionDetails(orderNumber).then((subscription) => {
         if (subscription !== null) {
            setShowModal(false);
            void cartStore.startEditSubscriptionMode(subscription);
            redirectTo("/checkout/cart");
         }
      });
   };

   const options = subscriptionStore.subscriptionsList.data.map((sub) => ({ label: sub.name, value: sub.orderNumber }));
   return (
      <>
         {showModal && <Loading modal label="Henter abonnementsdetaljer..." />}
         <ShortcutBox>
            <h4>Mine abonnement</h4>
            <p>Se oversikt over dine abonnement, eller velg et abonnement for å endre alle fremtidige leveringer.</p>

            <Button to="/customer/subscriptions" variant="secondary" className="my-2">
               Alle abonnement
            </Button>

            <Select
               label=""
               options={options}
               value={{ label: "Endre abonnement", value: "", isDisabled: true }}
               onChange={(option) => startEdit(option.value || null)}
               zOnOpen={30}
            />
         </ShortcutBox>
      </>
   );
};

export default observer(ShortcutChangeSubscription);
